import React, { type ReactNode } from 'react';

import { Box, Flex, Icon } from 'core/components';

interface Props {
  children: ReactNode;
}

const FilterDisplayRow = ({ children }: Props) => (
  <Flex flexWrap="wrap" alignItems="center" gap="4px" fontSize="small" mt="4px" pl="4px">
    <Box position="relative" top={-1} mr="-2px">
      <Icon icon="nest" color="muted" iconSize={11} />
    </Box>
    {children}
  </Flex>
);

export default FilterDisplayRow;
